
export default {
  simplePlaceSearch: {
    noPlaceFound: 'Nenhum local encontrado para o conteúdo inserido',
    openSidebarToSeeRouteDetails: 'Abrir a barra lateral para exibir os detalhes',
    unknownSearchPlaceError: 'Erro desconhecido ao buscar local'
  }
}
